module.exports = __webpack_public_path__ + "static/img/kiwibackground.1ab992d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kiwibackground.jpg
// module id = Fu7B
// module chunks = 63